import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MessageProvider } from 'src/app/providers/message.provider';
import { UsuarioProvider } from 'src/app/providers/usuario.provider';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        private usuarioProvider: UsuarioProvider,
        private messageProvider: MessageProvider,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const arrayEndpointsAuth = ['tokenAcesso', 'challenge'];
        const usuarioLogado = this.usuarioProvider.getUsuario();
        const tokenEnviado = usuarioLogado && usuarioLogado.token ? usuarioLogado.token.accessToken : null;
        const splitUrl = request.url.split('/');
        if (usuarioLogado && usuarioLogado.token.accessToken && arrayEndpointsAuth.indexOf(splitUrl[splitUrl.length - 1]) < 0) {
            let headerNovo: any = undefined;
            if (usuarioLogado.perfil && usuarioLogado.esfera && (request.url.indexOf('scpa') === -1 && request.url.indexOf('corporativo') === -1) && !request.url.includes('refresh-token')) {
                const splitEsfera = usuarioLogado.esfera.esferaAtuacao.split('/');
                const esfera = splitEsfera[splitEsfera.length - 1];
                headerNovo = {
                    Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken,
                    'X-Role-UsuarioLogado': 'ROLE_CNES_' + (usuarioLogado.esfera.sigla == "ESTREC" ? usuarioLogado.esfera.sigla : usuarioLogado.perfil.sigla),
                    'X-Esfera-UsuarioLogado': usuarioLogado.esfera.sigla == "ESTREC" ? usuarioLogado.esfera.esferaAtuacao : esfera,
                    'Accept' : request.headers.getAll('Accept') && request.headers.getAll('Accept').includes('application/json, application/pdf') ? 'application/json, application/pdf' : 'application/json, text/plain, */*,'
                };
            } else {
                headerNovo = {
                    Authorization: 'Bearer ' + this.usuarioProvider.getUsuario().token.accessToken,
                    'Accept' : 'application/json, text/plain, */*,'
                };
            }
            request = request.clone({
                setHeaders: headerNovo,
                withCredentials: true
            });
        }

        return next.handle(request).pipe(
            catchError((err) => {
                console.log(err);
                if (err.status === 401 && this.refreshComTokenSubstituido(request, tokenEnviado)) {
                    // refresh já concluído por outra chamada: o 401 veio do token antigo, a sessão continua válida
                    return throwError(err);
                }
                if (err.status === 401 && !this.urlNotificacaoSemSessaoExpirada(request.url)) { // retirando mensagem de usuário não logado para API de notificação
                    this.usuarioProvider.setUsuario(null);
                    this.messageProvider.showToast('Sessão expirada, por favor, realize login novamente.');
                    this.router.navigate(['/login']);
                }
                return throwError(err);
            })
        );
    }

    private urlNotificacaoSemSessaoExpirada(url: string): boolean {
        return url.includes('/notificacao/nao-visualizada') || url.includes('/notificacao/nao-lidas');
    }

    private refreshComTokenSubstituido(request: HttpRequest<any>, tokenEnviado: string): boolean {
        const usuarioAtual = this.usuarioProvider.getUsuario();
        return request.url.includes('refresh-token')
            && !!usuarioAtual && !!usuarioAtual.token
            && usuarioAtual.token.accessToken !== tokenEnviado;
    }
}
